import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import api from '../services/api';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const refreshUser = useCallback(async () => {
    try {
      const u = await api.getMe();
      setUser(u);
    } catch {
      setUser(null);
    }
  }, []);

  useEffect(() => {
    refreshUser().finally(() => setLoading(false));
  }, [refreshUser]);

  const logout = async () => {
    await api.logout();
    setUser(null);
    window.location.href = '/auth/login';
  };

  const startEmulation = async (resourceNo, name, userId) => {
    await api.emulateUser(resourceNo, name, userId);
    await refreshUser();
  };

  const stopEmulation = async () => {
    await api.stopEmulation();
    await refreshUser();
  };

  return (
    <AuthContext.Provider value={{ user, loading, logout, startEmulation, stopEmulation, refreshUser }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}
